import { z } from 'zod';

import { isISO8601 } from '../isISO8601';
import { ISODateString } from '../types';

import { PasswordRules } from './PasswordRules';

type CheckablePasswordPolicy = {
  type: 'custom';
  rules: PasswordRules;
  changeTime: ISODateString;
};

function isCheckablePasswordPolicy(
  passwordPolicy: PasswordPolicy,
): passwordPolicy is CheckablePasswordPolicy {
  return passwordPolicy.type !== 'none' && passwordPolicy.type !== 'unknown';
}

type PasswordPolicy =
  | CheckablePasswordPolicy
  | { type: 'none'; changeTime: ISODateString }
  | { type: 'unknown' };

const PasswordPolicy = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('custom'),
    rules: PasswordRules,
    // Use a constant default in the past for password policies created prior to the inclusion of
    // changeTime. This allows us to treat all policies the same.
    changeTime: z.string().refine(isISO8601).default('2025-06-01T00:00:00.000Z'),
  }),
  z.object({
    type: z.literal('none'),
    changeTime: z.string().refine(isISO8601),
  }),
  z.object({
    type: z.literal('unknown'),
  }),
]);

export { PasswordPolicy, type CheckablePasswordPolicy, isCheckablePasswordPolicy };
